/**
 * Shared business constants used across frontend and backend
 */

/**
 * Minimum order amount required to place an order (in GBP)
 * This is enforced after discounts are applied
 */
export const MINIMUM_ORDER_AMOUNT = 5;

/**
 * Display text for minimum order amount
 */
export const MINIMUM_ORDER_AMOUNT_TEXT = '£5.00';
